/* Fablix merged custom UI helpers for official Kalles */
(function(){
  'use strict';
  function qs(root, sel){return (root||document).querySelector(sel)}
  function qsa(root, sel){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function getResetUrl(){
    try{
      var url = new URL(window.location.href);
      var sort = url.searchParams.get('sort_by');
      return window.location.pathname + (sort ? '?sort_by=' + encodeURIComponent(sort) : '');
    }catch(e){return window.location.pathname || '/collections/all'}
  }
  function submitFacetForm(form){
    if(!form) return;
    var nativeSubmit = HTMLFormElement.prototype.submit;
    try{ form.requestSubmit ? form.requestSubmit() : nativeSubmit.call(form); }
    catch(e){ nativeSubmit.call(form); }
  }
  function syncPriceProgress(scope){
    qsa(scope,'.hdt-price-range').forEach(function(wrap){
      var ranges=qsa(wrap,'input[type="range"]');
      if(ranges.length<2) return;
      function update(){
        var min=parseFloat(ranges[0].min||0), max=parseFloat(ranges[0].max||100);
        var v1=parseFloat(ranges[0].value||min), v2=parseFloat(ranges[1].value||max);
        if(v1>v2){ var t=v1; v1=v2; v2=t; }
        var left=((v1-min)/(max-min))*100, right=100-(((v2-min)/(max-min))*100);
        wrap.style.setProperty('--min-progress', left+'%');
        wrap.style.setProperty('--max-progress', right+'%');
      }
      ranges.forEach(function(r){r.addEventListener('input',update);r.addEventListener('change',update)});
      update();
    });
  }
function ensureActions(dialog){
  if(!dialog || qs(dialog,'.fablix-filter-actions')) return;
  var inner = qs(dialog,'.hdt-dialog-drawer__inner') || dialog;
  var actions=document.createElement('div');
  actions.className='fablix-filter-actions';
  actions.innerHTML='<button type="button" class="fablix-filter-apply">Apply Filters</button><a class="fablix-filter-reset" href="'+getResetUrl()+'">Reset</a>';
  inner.appendChild(actions);
  var apply=qs(actions,'.fablix-filter-apply');
  apply.addEventListener('click',function(){
    var form=qs(dialog,'form');
    submitFacetForm(form);
  });
}
  function normalizeDetails(dialog){
    qsa(dialog,'details.hdt-widget').forEach(function(d){
      d.style.overflow='visible';
      var s=qs(d,'summary');
      if(s && !s.dataset.fablixReady){
        s.dataset.fablixReady='1';
        s.addEventListener('click',function(){
          setTimeout(function(){
            var inner=qs(dialog,'.hdt-dialog-drawer__inner');
            if(inner && d.open){
              var top=d.offsetTop-8;
              if(top<inner.scrollTop) inner.scrollTo({top:top,behavior:'smooth'});
            }
          },80);
        });
      }
    });
  }
  function init(root){
    qsa(root||document,'#hdt-filter_form, #hdt-shop-sidebar-drawer').forEach(function(dialog){
      ensureActions(dialog);
      normalizeDetails(dialog);
      syncPriceProgress(dialog);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('click',function(e){
    if(e.target && e.target.closest && e.target.closest('.hdt-filter_btn,[aria-controls="hdt-filter_form"],[aria-controls="hdt-shop-sidebar-drawer"]')){
      setTimeout(function(){init(document)},250);
    }
  },true);
  document.addEventListener('change',function(e){
    if(e.target && e.target.closest && e.target.closest('#hdt-filter_form')) setTimeout(function(){syncPriceProgress(document)},30);
  },true);
  document.addEventListener('shopify:section:load',function(e){init(e.target||document)});
})();
